import { render, staticRenderFns } from "./MySalesPerformance.vue?vue&type=template&id=3a2967c6"
import script from "./MySalesPerformance.vue?vue&type=script&lang=js"
export * from "./MySalesPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports